import { Component, Input } from '@angular/core';
import { AbstractBreezeListComponent } from '@common/classes/breeze-list';
import { BreezeViewService } from '@common/services/breeze-view.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { RowClassArgs } from '@progress/kendo-angular-grid';
import { ChatNoteModalComponent } from '../chat-note-modal/chat-note-modal.component';

@Component({
    selector: 'app-chat-notes-list',
    templateUrl: './chat-notes-list.component.html',
    styleUrls: ['./chat-notes-list.component.scss'],
    providers: [BreezeViewService]
})
export class ChatNotesListComponent extends AbstractBreezeListComponent {
    queryName = 'ChatNotes';
    persistFilter = false;
    @Input() vesselNotificationId: number;
    @Input() isModal = false;

    breadcrumb = [
        {
            icon: 'comments',
            title: 'Chat Notes'
        }
    ];

    constructor(protected breezeViewService: BreezeViewService, public activeModal: NgbActiveModal) {
        super(breezeViewService);
        this.actionBar[0].items[0].onClick = () => this.openNoteModal(null);
    }

    getDefaultFilter() {
        return {
            vesselNotificationId: this.vesselNotificationId
        };
    }

    openNoteModal(note) {
        this.breezeViewService.dialogService.open(ChatNoteModalComponent, {
            windowClass: 'full-screen-modal',
            scrollable: true,
        }, dialogRef => {
            dialogRef.componentInstance.vesselNotificationId = this.vesselNotificationId;
            if (note) dialogRef.componentInstance.parentNote = note;
            else dialogRef.componentInstance.addNewNote();
        }).then((res: any) => {
            if (note?.id && !res.isSeen) this.breezeViewService.handleCommand('SetViewedChatNote', { id: note.id }, true);
            this.search();
        });
    }

    close() {
        this.activeModal.close();
    }

    isSeen(note: any): boolean {
        return note?.seenByUsers.some(x => x.userId === this.user?.id);
    }

    public getRowClass = (context: RowClassArgs) => {
        const unreadChat = !this.isSeen(context.dataItem);
        return { unreadChat };
    };
}
